(function () {
  // ── Config ────────────────────────────────────────────────────────────────
  const SESSIONS = [
    { open: { h: 11, m: 30 }, close: { h: 14, m: 30 } },
    { open: { h: 18, m: 0  }, close: { h: 20, m: 30 } },
  ];
  const CLOSED_DAYS   = [1];   // 1 = Monday
  const SLOT_INTERVAL = 30;    // minutes per slot
  const WINDOW_DAYS   = 7;     // calendar shows next 7 open days (today included)

  // ── Theme overlay helpers ─────────────────────────────────────────────────
  function lockCheckout() {
    const drawer = document.getElementById("CartDrawer");
    if (drawer) drawer.setAttribute("loading", "");
    const mainCart = document.getElementById("MainCart");
    if (mainCart) mainCart.setAttribute("effect-blur", "");
  }
  function unlockCheckout() {
    const drawer = document.getElementById("CartDrawer");
    if (drawer) drawer.removeAttribute("loading");
    const mainCart = document.getElementById("MainCart");
    if (mainCart) mainCart.removeAttribute("effect-blur");
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function toMin(h, m) { return h * 60 + m; }
  function isClosedDay(date) { return CLOSED_DAYS.includes(date.getDay()); }
  function todayMidnight() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0, 0);
  }
  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
           a.getMonth()    === b.getMonth()    &&
           a.getDate()     === b.getDate();
  }
  function nowMins() {
    const n = new Date();
    return n.getHours() * 60 + n.getMinutes() + n.getSeconds() / 60;
  }

  // Now starts the window at TODAY instead of tomorrow.
  function getSelectableDates() {
    const dates  = [];
    const today  = todayMidnight();
    let   cursor = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    for (let i = 0; i < 14 && dates.length < WINDOW_DAYS; i++) {
      if (!isClosedDay(cursor)) {
        dates.push(new Date(cursor));
      }
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1);
    }
    return dates;
  }

  // Unchanged — this already enforces "slot start must be >= now + 30 min" for today.
  function getSlotsForDate(date) {
    const slots = [];
    const isToday = sameDay(date, new Date());
    const cutoff = isToday ? nowMins() + 30 : -1;

    for (const s of SESSIONS) {
      let slot = toMin(s.open.h, s.open.m);
      const end = toMin(s.close.h, s.close.m);
      while (slot < end) {
        if (!isToday || slot >= cutoff) {
          slots.push(slot);
        }
        slot += SLOT_INTERVAL;
      }
    }
    return slots;
  }

  function fmtSlot(startMin) {
    return `${fmtTime(startMin)} – ${fmtTime(startMin + SLOT_INTERVAL)}`;
  }
  function fmtTime(min) {
    const h = Math.floor(min / 60), m = min % 60;
    return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
  }
  function fmtDateLabel(d) {
    if (sameDay(d, new Date())) {
      return `Today, ${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
    }
    return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
  }
  function fmtDateValue(d) {
    const month = d.toLocaleDateString("en-US", { month: "short" });
    return `${String(d.getDate()).padStart(2, "0")} ${month}, ${d.getFullYear()}`;
  }

  // ── Store open/closed status ──────────────────────────────────────────────
  function getStoreStatus() {
    const today = todayMidnight();
    const todayClosed = isClosedDay(today);
    const nowMin = nowMins();

    let isOpen = false;
    if (!todayClosed) {
      for (const s of SESSIONS) {
        const open  = toMin(s.open.h, s.open.m);
        const close = toMin(s.close.h, s.close.m);
        if (nowMin >= open && nowMin < close) { isOpen = true; break; }
      }
    }

    return { isOpen };
  }

  // ── Save to cart ──────────────────────────────────────────────────────────
  let saveTimer = null;
  function saveAll(pickerId) {
    clearTimeout(saveTimer);
    lockCheckout();
    saveTimer = setTimeout(async () => {
      try {
        const dateSelect   = document.getElementById(pickerId + "-DateSelect");
        const timeSelect   = document.getElementById(pickerId + "-Time");
        const cutleryYes   = document.getElementById(pickerId + "-Cutlery-Yes");
        const allergyCheck = document.getElementById(pickerId + "-Allergy-Check");
        const allergyText  = document.getElementById(pickerId + "-Allergy-Text");

        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              "Pickup Date":    dateSelect   ? dateSelect.value  : "",
              "Pickup Time":    timeSelect   ? timeSelect.value  : "",
              "Cutlery Required": (cutleryYes && cutleryYes.checked) ? "Yes" : "No",
              "Special Requests": (allergyCheck && allergyCheck.checked && allergyText)
                                   ? allergyText.value.trim() : "",
            },
          }),
        });
      } catch (err) {
        console.error("[delivery-picker] save failed:", err);
      } finally {
        unlockCheckout();
      }
    }, 100);
  }

  // ── Init a single picker instance ─────────────────────────────────────────
  function initPicker(pickerId) {
    try {
      const picker = document.getElementById(pickerId);
      if (!picker) return;

      const dateSelect   = document.getElementById(pickerId + "-DateSelect");
      const timeSelect   = document.getElementById(pickerId + "-Time");
      const allergyCheck = document.getElementById(pickerId + "-Allergy-Check");
      const allergyField = document.getElementById(pickerId + "-Allergy-Field");

      if (!dateSelect || !timeSelect) {
        setTimeout(() => initPicker(pickerId), 100);
        return;
      }

      // Clone selects to drop stale listeners
      const newDate = dateSelect.cloneNode(false);
      dateSelect.parentNode.replaceChild(newDate, dateSelect);
      const newTime = timeSelect.cloneNode(false);
      timeSelect.parentNode.replaceChild(newTime, timeSelect);

      // ── Populate date dropdown ──────────────────────────────────────────
      const selectableDates = getSelectableDates();
      newDate.innerHTML = "";
      selectableDates.forEach(d => {
        const opt = document.createElement("option");
        opt.value       = fmtDateValue(d);
        opt.textContent = fmtDateLabel(d);
        newDate.appendChild(opt);
      });

      function fillTimes(date) {
        newTime.innerHTML = "";
        const slots = getSlotsForDate(date);
        if (slots.length === 0) {
          const opt = document.createElement("option");
          opt.value = "";
          opt.textContent = "No slots available";
          newTime.appendChild(opt);
        } else {
          slots.forEach(min => {
            const opt = document.createElement("option");
            opt.value = opt.textContent = fmtSlot(min);
            newTime.appendChild(opt);
          });
        }
      }

      // Pre-select first date and fill times
      fillTimes(selectableDates[0] || new Date());
      saveAll(pickerId);

      // Date change → refresh time slots
      newDate.addEventListener("change", () => {
        const selected = new Date(newDate.value);
        fillTimes(selected);
        saveAll(pickerId);
      });

      // Time change
      newTime.addEventListener("change", () => saveAll(pickerId));

      // Cutlery
      [pickerId + "-Cutlery-Yes", pickerId + "-Cutlery-No"].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.addEventListener("change", () => saveAll(pickerId));
      });

      // Allergy checkbox
      if (allergyCheck && allergyField) {
        const newCheck = allergyCheck.cloneNode(true);
        allergyCheck.parentNode.replaceChild(newCheck, allergyCheck);
        newCheck.addEventListener("change", () => {
          allergyField.style.display = newCheck.checked ? "block" : "none";
          if (!newCheck.checked) {
            const t = document.getElementById(pickerId + "-Allergy-Text");
            if (t) t.value = "";
          }
          saveAll(pickerId);
        });
        const allergyText = document.getElementById(pickerId + "-Allergy-Text");
        if (allergyText) {
          let allergyTimer = null;
          allergyText.addEventListener("input", () => {
            clearTimeout(allergyTimer);
            allergyTimer = setTimeout(() => saveAll(pickerId), 400);
          });
        }
      }

    } catch (err) {
      console.error("[delivery-picker] initPicker error:", err);
    }
  }

  // ── Init all pickers ──────────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll(".hdt-delivery-picker").forEach(el => initPicker(el.id));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  [
    "cart:refresh", "cart:updated", "cart-drawer:open", "cart-drawer:opened",
    "hdt:cart-updated", "hdt:drawer-opened", "hdt:section-rendered", "shopify:section:load",
  ].forEach(evt => document.addEventListener(evt, initAll));

  // ── Clear attributes when cart is emptied ────────────────────────────────
  async function clearAttributesIfEmpty() {
    try {
      const res  = await fetch("/cart.js");
      const cart = await res.json();
      if (cart.item_count === 0) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              "Pickup Date":    "",
              "Pickup Time":    "",
              "Cutlery Required": "",
              "Special Requests": "",
              "Delivery Date":    "",
              "Delivery Time":    "",
            },
            note: " ",
          }),
        });
      }
    } catch (err) {
      console.error("[delivery-picker] clear attributes failed:", err);
    }
  }

  ["cart:refresh", "cart:updated", "hdt:cart-updated"]
    .forEach(evt => document.addEventListener(evt, clearAttributesIfEmpty));

  // ── MutationObserver ──────────────────────────────────────────────────────
  const observer = new MutationObserver(mutations => {
    let found = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList?.contains("hdt-delivery-picker") || node.querySelector?.(".hdt-delivery-picker")) {
          found = true; break;
        }
      }
      if (found) break;
    }
    if (found) requestAnimationFrame(() => initAll());
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();